// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get, chain } from 'lodash';

import AppInstallBanner from './AppInstallBanner/AppInstallBanner';
import SmokeBanner from './SmokeBanner/SmokeBanner';
import ProfileBanner from './ProfileBanner/ProfileBanner';

import { isCampaignActive } from 'src/modules/is-campaign-active';
import { isATargetDevice } from 'src/modules/app-install-banner';

type Props = {
  locale: Locale,
  bannerCookie?: string
};

type BannerRun = {
  from?: string,
  to?: string,
  component: any
};

type BannerRunSheet = {
  AU: Array<BannerRun>,
  NZ: Array<BannerRun>
};

const banners = {
  smoke: SmokeBanner,
  profile: ProfileBanner
};

const bannerRunSheet: BannerRunSheet = {
  AU: [{ component: SmokeBanner }],
  NZ: []
};

const getCurrentlyQueuedBanner = (runSheet: BannerRunSheet, locale) => {
  return chain(runSheet)
    .get(locale)
    .find(isCampaignActive)
    .get('component', ProfileBanner)
    .value();
};

const mapStateToProps = ({ location, featureFlags }) => ({
  locale: location.locale,
  bannerCookie: featureFlags.homepageBanners
});

class HomePageBanner extends PureComponent<Props> {
  props: Props;

  render() {
    const { bannerCookie, locale } = this.props;
    const ActiveBanner = get(
      banners,
      bannerCookie,
      isATargetDevice(['iPhone', 'Android'])
        ? AppInstallBanner
        : getCurrentlyQueuedBanner(bannerRunSheet, locale)
    );
    return <ActiveBanner />;
  }
}

export default connect(mapStateToProps)(HomePageBanner);
